const enUsCopy = {
    header: {
      brandLabel: 'ADFINI.AI',
      nav: [
        { id: 'transformations', label: 'Transformations' },
        { id: 'modes', label: 'Modes' },
        { id: 'pricing', label: 'Pricing' },
        { id: 'faq', label: 'FAQ' },
      ],
      signIn: 'Sign In',
      getStarted: 'Get Started',
    },
    hero: {
      titleLead: 'AI Ad Studio for',
      titleAccent: 'Modern Brands',
      description:
        'Create production-ready ads, images and videos from a single product input. No shoots. No editing. Just results.',
      primaryCta: 'Start Creating Free',
      trustPoints: [
        'No credit card required',
        'Ready in minutes',
        'Commercial use allowed',
      ],
      visual: {
        uploadLabel: 'Upload Product',
        uploadCaption: 'Original Product',
        outputs: [
          {
            id: 'editorial',
            title: 'Editorial Image',
            caption: 'Magazine-quality still',
            kind: 'image',
          },
          {
            id: 'lifestyle',
            title: 'Lifestyle Shot',
            caption: 'Story-first composition',
            kind: 'image',
          },
          {
            id: 'social',
            title: 'Social Ad',
            caption: 'Optimized for paid social',
            kind: 'image',
          },
          {
            id: 'video',
            title: 'Video Frame',
            caption: 'Motion-ready visual',
            kind: 'video',
          },
          {
            id: 'campaign',
            title: 'Campaign Visual',
            caption: 'Cross-channel creative',
            kind: 'image',
          },
        ],
      },
    },
    campaignFlow: {
      title: 'From Single Input to Full Campaign',
      subtitle: 'One product image. Endless creative possibilities.',
      steps: [
        {
          id: 'upload',
          label: '1. Upload',
          description: 'Any clear product photo.',
          icon: 'upload',
        },
        {
          id: 'engine',
          label: '2. AI Creative Engine',
          description: 'Understands your product and intent.',
          icon: 'creative',
        },
        {
          id: 'generate',
          label: '3. Generate',
          description: 'Multiple ad-ready assets in seconds.',
          icon: 'generate',
        },
        {
          id: 'anywhere',
          label: '4. Use Anywhere',
          description: 'For ads, stores, social and more.',
          icon: 'use',
        },
      ],
      socialPlatforms: [
        { id: 'instagram', label: 'Instagram' },
        { id: 'facebook', label: 'Facebook' },
        { id: 'tiktok', label: 'TikTok' },
      ],
    },
    modes: {
      title: 'Creative Modes for Every Need',
      subtitle: 'Choose fast and built matches for your story.',
      cards: [
        {
          id: 'jewelry',
          badge: 'Popular',
          title: 'Jewelry Catalogue',
          description: 'Upload product shots for your store or collection.',
        },
        {
          id: 'ecommerce',
          title: 'Ecommerce Studio',
          description: 'Clean, conversion-ready visuals for product listings.',
        },
        {
          id: 'story',
          title: 'Lifestyle Storytelling',
          description: 'Natural visuals tuned for brand narrative.',
        },
        {
          id: 'cinematic',
          title: 'Cinematic Product Ads',
          description: 'High-impact ad frames built for campaigns.',
        },
        {
          id: 'editorial',
          title: 'Editorial Lookbook',
          description: 'Magazine-style visual direction for premium brands.',
        },
        {
          id: 'more',
          title: 'More Modes',
          description: 'Fashion, beauty and additional genres coming soon.',
        },
      ],
    },
    outputs: {
      title: 'Stunning Outputs, Every Time.',
      subtitle: 'Generated by brands. Loved by creators.',
    },
    valueProps: {
      title: 'Why Teams Love Adfini',
      subtitle: 'Built for speed. Designed for scale.',
      items: [
        {
          title: '10x Faster Production',
          description: 'Create in minutes, not weeks. No bottlenecks.',
          icon: 'speed',
        },
        {
          title: 'Endless Variations',
          description: 'Generate multiple concepts and angles instantly.',
          icon: 'variation',
        },
        {
          title: 'Production-Ready Quality',
          description: 'High-resolution outputs for commercial use.',
          icon: 'quality',
        },
        {
          title: 'No Creative Skills Needed',
          description: 'Adfini handles complexity while you stay in control.',
          icon: 'ease',
        },
      ],
    },
    pricing: {
      title: 'A Plan for Every Creator',
      subtitle: 'Credit packs for jewelry video runs. 10 credits ≈ US$1.',
      creditRateNote: 'Pricing: 10 credits = US$1. Longer videos add 30 credits per extra 15 seconds (30s = 60 credits, 45s = 90).',
      freeCreditsNote: 'New users get 30 free credits — enough for one 15s video.',
      plans: [
        {
          id: 'starter',
          name: 'Starter Pack',
          price: '$3',
          period: '',
          credits: '30 credits · 1× 15s video',
          planDetails:
            'Rough guide if you pick longer cuts: ~0 full 30s runs (60 cr each) · ~0 full 45s runs (90 cr each). Top up or choose a larger pack for 30s/45s.',
          cta: 'Get Started',
          features: ['30 credits', '1× 15 second video', 'Commercial use'],
        },
        {
          id: 'pro',
          name: 'Professional Pack',
          price: '$15',
          period: '',
          credits: '150 credits · 5× 15s videos',
          planDetails: 'Rough guide: ~2× 30s runs (60 cr) · ~1× 45s run (90 cr) per equivalent usage.',
          badge: 'Most Popular',
          cta: 'Get Started',
          features: ['150 credits', '5× 15 second videos', 'Commercial use'],
        },
        {
          id: 'enterprise',
          name: 'Enterprise Pack',
          price: '$60',
          period: '',
          credits: '600 credits · 20× 15s videos',
          planDetails: 'Rough guide: ~10× 30s runs · ~6–7× 45s runs.',
          cta: 'Get Started',
          features: ['600 credits', '20× 15 second videos', 'Commercial use'],
        },
      ],
      footnote: 'All packs include commercial usage rights. Video length affects credits per run.',
      refundPolicyBeforeLink: 'Paid purchases are subject to our ',
      refundPolicyLink: 'Refund Policy',
      refundPolicyAfterLink: '.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      viewAll: 'View all FAQs',
      items: [
        {
          question: 'What file formats do you support?',
          answer: 'You can upload JPG, PNG and HEIC product images.',
        },
        {
          question: 'How long does generation take?',
          answer: 'Most images are ready in under 2 minutes. Video-ready outputs may take a bit longer.',
        },
        {
          question: 'Can I use the outputs for commercial purposes?',
          answer: 'Yes. Generated outputs can be used across paid and organic channels.',
        },
        {
          question: 'Can I generate video assets as well?',
          answer: 'Yes. You can generate motion-ready frames and short-form creative outputs.',
        },
        {
          question: 'Do I need any design or editing skills?',
          answer: 'No. The platform is built for non-designers and experienced teams alike.',
        },
        {
          question: 'Which industries will Adfini support?',
          answer: 'Jewelry is live now, with additional verticals expanding next.',
        },
      ],
    },
    footer: {
      description: 'AI Ad Studio for modern brands. Create. Transform. Scale.',
      columns: [
        {
          title: 'Product',
          links: [
            { label: 'Transformations', href: '#transformations' },
            { label: 'Modes', href: '#modes' },
            { label: 'Pricing', href: '#pricing' },
          ],
        },
      ],
      newsletterTitle: 'Stay in the loop',
      newsletterDescription: 'Get updates about new modes and features.',
      emailPlaceholder: 'Enter your email',
      copyright: 'All rights reserved.',
      legalLinks: [
        { label: 'Privacy Policy', href: '/privacy' },
        { label: 'Terms of Service', href: '/terms' },
        { label: 'Refund Policy', href: '/refund-policy' },
        { label: 'Help & Support', href: '/help' },
      ],
    },
    mediaAlt: {
      logo: 'Adfini logo',
      uploadProduct: 'Uploaded product',
      outputEditorial: 'Editorial output preview',
      outputLifestyle: 'Lifestyle output preview',
      outputSocial: 'Social ad output preview',
      outputVideo: 'Video output frame preview',
      outputCampaign: 'Campaign output preview',
      modeCard: 'Creative mode preview',
      gallery: 'Generated output example',
    },
};

const enInCopy = {
  ...enUsCopy,
  modes: {
    ...enUsCopy.modes,
    cards: enUsCopy.modes.cards.map((card) => {
      if (card.id === 'jewelry') return { ...card, title: 'Jewellery Catalogue' };
      return card;
    }),
  },
  faq: {
    ...enUsCopy.faq,
    items: enUsCopy.faq.items.map((item) =>
      item.question.includes('industries')
        ? { ...item, answer: 'Jewellery is live now, with additional verticals expanding next.' }
        : item
    ),
  },
};

const homePageLocales = {
  'en-US': enUsCopy,
  'en-IN': enInCopy,
};

export const getHomePageCopy = (locale = 'en-US') => {
  return homePageLocales[locale] || homePageLocales['en-US'];
};
